import React, { Component } from 'react';

import logo from './logo.svg';
import downloadOnTheAppStore from './Download_on_the_App_Store_Badge_RU_RGB_wht_100317.svg';
import screen1 from './assets/screens/1.png';
import screen2 from './assets/screens/2.png';
import screen3 from './assets/screens/3.png';
import screen4 from './assets/screens/4.png';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: 0,
    };
  }

  componentDidMount() {
    this.interval = window.setInterval(
      () => this.setState({ slide: (this.state.slide + 1) % 4 }),
      3000
    );
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  render() {
    return (
      <div className="landing">
        <header>
          <div className="container-flex flex-row">
            <div className="header-title">
              <img src={logo} alt="Чем заняться" />
              <div className="section-description">
                Приложение с событиями
                <span className="desktop-only"> на любой вкус</span>.<br />
                Создавай свои, участвуй в других.
              </div>
              <a
                href="https://apps.apple.com/us/app/чем-заняться/id1544506865"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="Загрузите в App Store" src={downloadOnTheAppStore} />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.pistonsky.activities&utm_source=4eze.ru&utm_campaign=4eze.ru&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  alt="Доступно в Google Play"
                  src="https://play.google.com/intl/ru_ru/badges/static/images/badges/ru_badge_web_generic.png"
                />
              </a>
            </div>
            <div className="header-img">
              <div className="phone-img">
                <div className="phone-img-container">
                  <img
                    alt="header-phone"
                    src={screen1}
                    style={{
                      opacity: this.state.slide === 0 ? 1 : 0,
                    }}
                  />
                  <img
                    alt="header-phone"
                    src={screen2}
                    style={{
                      opacity: this.state.slide === 1 ? 1 : 0,
                    }}
                  />
                  <img
                    alt="header-phone"
                    src={screen3}
                    style={{
                      opacity: this.state.slide === 2 ? 1 : 0,
                    }}
                  />
                  <img
                    alt="header-phone"
                    src={screen4}
                    style={{
                      opacity: this.state.slide === 3 ? 1 : 0,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default App;
